/* eslint-disable prettier/prettier */
export const makeDrawerItem = (scene: string, heading: string, subHeading: string) => {
  return {
    scene: scene,
    heading: heading,
    subHeading: subHeading,
  };
};

export const getOpSys = () => {
  let os = '';

  const userAgent = window.navigator.userAgent;
  const platform = window.navigator.platform;
  const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
  const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
  const iosPlatforms = ['iPhone', 'iPad', 'iPod'];

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'IOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else if (/Linux/.test(platform)) {
    os = 'Linux';
  }

  return os;
};

export const isValidUrl = (urlString: string) => {
  const urlPattern = new RegExp(
    '^(https?:\\/\\/)?' + // validate protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
    '(\\#[-a-z\\d_]*)?$',
    'i',
  ); // validate fragment locator
  return !!urlPattern.test(urlString);
};

export const getBrowserName = () => {
  const userAgent = window.navigator.userAgent;
  let browserName = 'Unknown';

  if (userAgent.includes('Chrome')) {
    browserName = 'Google Chrome';
  } else if (userAgent.includes('Firefox')) {
    browserName = 'Mozilla Firefox';
  } else if (userAgent.includes('Edge')) {
    browserName = 'Microsoft Edge';
  } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    browserName = 'Apple Safari';
  } else if (userAgent.includes('Opera') || userAgent.includes('OPR')) {
    browserName = 'Opera';
  } else if (userAgent.includes('Trident')) {
    browserName = 'Internet Explorer';
  }

  return browserName;
};

export const returnLoccitaneLocale = (locale: string) => {
  const lang = locale.split("-")[0];
  const market = locale.split("-")[1];

  return lang + "_" + market.toUpperCase();
}


export const undoLoccitaneLocale = (locale: string) => {
  const lang = locale?.split("_")[0];
  const market = locale?.split("_")[1];

  return lang + "-" + market?.toLowerCase();
}

export const getParameter = (searchString: string, paramName: string) => {
  let i = 0;
  let val = [];
  const params = searchString.split('&');

  for (i = 0; i < params.length; i++) {
    val = params[i].split('=');
    if (val[0] === paramName) {
      return val[1];
    }
  }
  return null;
}

export function findNonCommonItems(array1: string[], array2: string[]) {
  const nonCommonArray1 = array1.filter((item) => !array2.includes(item));
  const nonCommonArray2 = array2.filter((item) => !array1.includes(item));
  return [...nonCommonArray1, ...nonCommonArray2];
}

export function mergeArraysUnique(array1: string[], array2: string[]) {
  const mergedArray = [...array1];

  for (const item of array2) {
    if (!mergedArray.includes(item)) {
      mergedArray.push(item);
    }
  }

  return mergedArray;
}